<div class="base-res-wm loading-base" >
    <!-- 
    <div class="loading-img">
        <img src="/assets/family-project/loading.gif"/>
    </div>
    -->
</div>

